export default __webpack_public_path__ + "static/media/add.ba30e755.svg";